import Joi from 'joi';

const RETURN_NOTES_MIN_LENGTH = 25;
const REVIEW_EVENT_WARNING_MESSAGE =
  'Comment field is required. Must be a minimum of 25 characters.';

const EventReturnInputValidator = {
  schema: Joi.object({
    returnNotes: Joi.string().min(RETURN_NOTES_MIN_LENGTH).required().messages({
      'string.empty': REVIEW_EVENT_WARNING_MESSAGE,
      'string.min': REVIEW_EVENT_WARNING_MESSAGE
    })
  })
};

export default EventReturnInputValidator;
